import React from 'react'
import {Box, Typography} from '@mui/material'

interface EmptyStateProps {
  icon?: React.ReactNode
  title: string
  description?: string
}

export default function EmptyState({icon, title, description}: EmptyStateProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 0.5,
        textAlign: 'center',
      }}
    >
      {icon && (
        <Box sx={{mb: 2, display: 'flex', alignItems: 'center'}}>
          {icon}
        </Box>
      )}
      <Typography variant="h3" sx={{mb: description ? 1 : 0}}>
        {title}
      </Typography>
      {description && (
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
      )}
    </Box>
  )
}
